import { UniqueIdentifier, useDroppable } from '@dnd-kit/core';

export default function DroppableContainer({
  id,
  className,
  children,
}: {
  id: UniqueIdentifier;
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}) {
  const { setNodeRef } = useDroppable({ id });

  return (
    <div ref={setNodeRef} className={className}>
      {children}
    </div>
  );
}
